module.exports = __webpack_public_path__ + "img/img-afae7528.2cb6f16d.png";